import { Dot } from './Dot';
import { Button } from './Button';
import ResponsiveCarousel from './ResponsiveCarousel';
import Carousel from './Carousel';
import InfiniteCarousel from './InfiniteCarousel';

ResponsiveCarousel.Dot = Dot;
ResponsiveCarousel.Button = Button;
Carousel.Dot = Dot;
Carousel.Button = Button;
InfiniteCarousel.Dot = Dot;
InfiniteCarousel.Button = Button;

export { Carousel, InfiniteCarousel, ResponsiveCarousel };